import React, { useState } from 'react';
import { APIKeyService } from '../../../../../services/APIKeyService';
import { APIKeyForm } from './components/APIKeyForm';
import { APIKeyDisplay } from './components/APIKeyDisplay';

interface ModalProps {
  onSubmit: (succeeded?: boolean) => void;
  onClose: (succeeded?: boolean) => void;
}

export function ModalBody({ onClose, onSubmit }: ModalProps) {
  const [apiKeyName, setApiKeyName] = useState<string>('');
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [token, setToken] = useState<string>(undefined);

  const isFormValid = apiKeyName.trim().length > 0;

  const handleSubmit = async (e?: React.FormEvent) => {
    if (e) e.preventDefault();

    if (!isFormValid || isSaving) return;

    setIsSaving(true);
    try {
      const data = await APIKeyService.create(apiKeyName.trim());
      setToken(data.token);
      onSubmit(true);
    } catch (error) {
      onClose(false);
      console.error(error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <>
      {token ? (
        <APIKeyDisplay
          apiKeyName={apiKeyName}
          token={token}
          onClose={() => onClose(true)}
        />
      ) : (
        <APIKeyForm
          apiKeyName={apiKeyName}
          setApiKeyName={setApiKeyName}
          isSaving={isSaving}
          isFormValid={isFormValid}
          onClose={() => onClose()}
          onSubmit={handleSubmit}
        />
      )}
    </>
  );
}
